export default {
  apiKey: "AIzaSyBCCKfvR7w8oYeDqeYeOWiRkQppoX4LFcs",
  authDomain: "prisma-lotus.firebaseapp.com",
  projectId: "prisma-lotus",
  storageBucket: "prisma-lotus.appspot.com",
  messagingSenderId: "917330161651",
  appId: "1:917330161651:web:282a5d8a0f203232bbac86",
  measurementId: "G-WC1VBL4T59",
};
